import {
    ANALYTICS_CREATE_UPDATED_PII,
    ANALYTICS_IDENTIFY_USER,
    ANALYTICS_SELF_SERVICE_EMAIL_CHANGE_SUCCESS,
    ANALYTICS_SELF_SERVICE_PHONE_CHANGE_SUCCESS,
} from '@perpay-web/fintech/constants/actionTypes';

// Send updated user info to Facebook
export function analyticsUpdatedPII(payload) {
    return { type: ANALYTICS_CREATE_UPDATED_PII, payload };
}

export function analyticsIdentifyUser(payload) {
    return {
        type: ANALYTICS_IDENTIFY_USER,
        payload,
    };
}

export function analyticsSelfServiceEmailUpdateSuccess(payload) {
    return {
        type: ANALYTICS_SELF_SERVICE_EMAIL_CHANGE_SUCCESS,
        payload,
    };
}

export function analyticsSelfServicePhoneUpdateSuccess(payload) {
    return {
        type: ANALYTICS_SELF_SERVICE_PHONE_CHANGE_SUCCESS,
        payload,
    };
}
